export const CHANGE_CONNECTION_ERROR_PARAM = 'instagram_change_connection_error'
